import $ from 'jquery';
import _ from '_';
import React from 'react';
import ReactDOM from 'react-dom';
import Reflux from 'reflux';
import ChoiceStore from './choice-store';
import Utils from 'medscape/utils';

export default class PollResults extends React.Component {    
    constructor(props) {
        super(props);
        if(window.medscape.user.isLoggedIn){
            this.fixChoicesTotalResponse(props.question.choices);
        }
    }
    fixChoicesTotalResponse(choices){
        function getPercentages(percentages) {
            let numbers = percentages.map( (percentage,index)=>{
                let number = Math.floor(percentage);
                let decimal = percentage - number;
                return {
                    number: number,
                    decimal: decimal,
                    index: index
                };
            });

            let largestDec = numbers.sort( (number1,number2)=>{
                return number1.decimal < number2.decimal; 
            });
            let total = 0;
            numbers.forEach( (number) => {
                total += number.number;
            });
            let counter = 0;
            for(let i=total; i<100; i++){
                let index = largestDec[counter].index;
                numbers[index].number++;
                counter++;
            }
            percentages = numbers.map( (number) => {
                return number.number;
            })
            return percentages;
        }
        
        let totalResponses = 0;
        choices.forEach( (choice) => {
            if(choice.selected && choice.totalAbsoluteResponseCount==0){
                choice.totalAbsoluteResponseCount = 1;
            }
            totalResponses+=choice.totalAbsoluteResponseCount;
        })
        if(totalResponses===0) return;

        let percentages =  choices.map( (choice) => {
            return (choice.totalAbsoluteResponseCount/totalResponses)*100;
        })
        percentages = getPercentages(percentages);
        
        choices.forEach( (choice,index) => {
            choice.totalResponses = percentages[index];
        });

    } //fixChoicesTotalResponse
    getChoices(){


        let choicesMap = this.props.question.choices.map( (choice,index) => {
            let componentProps = {
                key: "choice-"+index,
                choice: choice
            }
            return ( <Choice {...componentProps} /> )
        });
        return choicesMap;
    }

    render() { 
        let choices = this.getChoices();
        if(choices.length==0) return false;
        return(
            <ul className="poll-results result-choices choices-container">
            { choices }
            </ul>
        )
    }
}
PollResults.propTypes={
    question: React.PropTypes.object.isRequired
}

PollResults.defaultProps={
}

class Choice extends React.Component{
    constructor(props) {
        super(props);
        this.state = props.choice;
        //this.store = ChoiceStore.get(this.props.choice);
    }
    getWidth(){
        let percentage = parseInt(this.state.totalResponses,10);
        let width = Math.round(percentage);
        width = width>100 ? 100 : width;
        width = width<0 ? 0 : width;
        return width;
    }
    componentDidMount() {
        let $this = $(ReactDOM.findDOMNode(this));
        let $bar = $this.find('.bar');
        let width = this.getWidth();
        setTimeout( () => {
            $bar.css('width', `${width}%`);
        },10);
    }
    componentDidUpdate(){
    }

    render() {
        let className = "choice-item";
        className += this.state.selected ? " active" : "";
        let choiceId = `choice-${this.state.choiceId}`;
        let percentage = parseInt(this.state.totalResponses,10);
        let width = this.getWidth();
        let text = {
            __html: this.state.choiceText
        }

        return(
            <li className={className}>
                <div className="result-container">
                    <span className="choice-text" dangerouslySetInnerHTML={text}></span>
                    <span className="percentage">{width}%</span>
                    <div className="bar"></div>
                </div>
            </li>
        )
    }
}

Choice.propTypes={
    choice: React.PropTypes.object.isRequired
}
Choice.defaultProps={
}


// WEBPACK FOOTER //
// ./medscape_modules/qna/form-components/choices/poll-results.jsx